import { Component, OnInit } from '@angular/core';
import { MensagemService, ProgressoService } from 'maestro-ng';
import { Frm } from '../../components/frm/frm.interface';
import { SelectItemService } from '../../services/select-item.service';
import { TipoProcessoDocumento } from '../../tipo-processo-documento/tipo-proc-doc.model';
import { TipoProcessoDocumentoService } from '../../tipo-processo-documento/tipo-proc-doc.service';
import { TipoProcessoDocumentoLocal } from '../tipo-proc-doc-loc.model';
import { TipoProcessoDocumentoLocalService } from '../tipo-proc-doc-loc.service';

@Component({
  selector: 'app-tipo-proc-doc-loc-frm',
  templateUrl: './tipo-proc-doc-loc-frm.component.html',
  styleUrls: ['./tipo-proc-doc-loc-frm.component.css'],
})
export class TipoProcessoDocumentoLocalFrmComponent implements OnInit, Frm<TipoProcessoDocumentoLocal, number> {
  entidade: TipoProcessoDocumentoLocal;

  public tipoProcessoDocumentoSugestoes: TipoProcessoDocumento[];

  constructor(
    private service: TipoProcessoDocumentoLocalService,
    private mensagemService: MensagemService,
    private progressoService: ProgressoService,
    public tipoProcessoDocumentoService: TipoProcessoDocumentoService,
    private selectItemService: SelectItemService
  ) {}

  ngOnInit(): void {
    this.entidade = {} as TipoProcessoDocumentoLocal;
  }

  public onCompleteTipoProcessoDocumento(termo: string) {
    this.progressoService.modeless();
    this.tipoProcessoDocumentoService
      .recuperarSugestoes(termo)
      .then((sugestoes) => {
        this.progressoService.fechar();
        this.tipoProcessoDocumentoSugestoes = sugestoes;
      })
      .catch((resposta) => {
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro ao carregar as sugestões de Tipo de Processo Documento!', resposta.error);
      });
  }

  salvar(): void {
    throw new Error('Método não implementado.');
  }

  iniciarInsercao(): void {
    throw new Error('Método não implementado.');
  }

  iniciarAlteracao(): void {
    throw new Error('Método não implementado.');
  }

  iniciarAlteracaoPorId(): void {
    throw new Error('Método não implementado.');
  }
}
